import { t } from '@glory/i18n';
import { Button, notify, PageHeader } from '@glory/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { postponeContractStep, useMyContractStep } from '../../../features/team/contract-step.tsx';
import { EmployeeDocumentsTab } from '../../../features/team/employee-documents.tsx';
import { useCrumbs } from '../../../lib/crumbs.tsx';
import { meQuery } from '../../../lib/session.ts';

export const Route = createFileRoute('/_app/profile/documents')({
  component: ProfileDocumentsPage,
});

/**
 * «Данные и договор» (подпроект 4.4): после принятия приглашения сотрудник заполняет свои данные по форме работы и
 * подписывает договор кодом из письма; здесь же его договоры и акты о выплатах. Шаг можно отложить — работа не
 * блокируется.
 */
function ProfileDocumentsPage() {
  const { data: me } = useSuspenseQuery(meQuery);
  const step = useMyContractStep();
  const navigate = useNavigate();
  useCrumbs([{ label: t('shell.profile'), href: '/profile' }, { label: t('documents.employee.stepTitle') }]);

  return (
    <div className="flex flex-col gap-4 px-4 py-5 md:px-6">
      <PageHeader
        crumb={me.email}
        title={t('documents.employee.stepTitle')}
        actions={
          step.data ? (
            <Button
              variant="ghost"
              onClick={() => {
                postponeContractStep();
                notify(t('documents.employee.postponed'));
                void navigate({ to: '/today' });
              }}
            >
              {t('documents.employee.postpone')}
            </Button>
          ) : null
        }
      />
      <p className="-mt-2 max-w-3xl text-muted">{t('documents.employee.stepLead')}</p>
      <div className="max-w-3xl">
        <EmployeeDocumentsTab employeeId={me.id} self />
      </div>
    </div>
  );
}
